<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Program</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Nama Program"
                class="mb-0 required is-invalid"
                type="text"
                required
                horizontal
                placeholder="Nama Program"
                :value="programData.program_name"
                :isValid="validate.program_name.isValid"
                :invalidFeedback="validate.program_name.message"
                @change="handleProgramName"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="program_slug"
                label="Program Url Name"
                class="mb-0 required"
                type="text"
                required
                horizontal
                placeholder="Program Url Name"
                :value="programData.program_name"
                :isValid="validate.program_slug.isValid"
                :invalidFeedback="validate.program_slug.message"
                v-model.trim="programData.program_slug"
                @change="handleProgramSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CTextarea
                id="meta_description"
                label="Meta Description"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Description"
                v-model="programData.meta_info_description"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CTextarea
                id="meta_description"
                label="Meta Keyword"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Keyword"
                v-model="programData.meta_info_keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Jenis Program"
                :options="options"
                required
                class="required"
                horizontal
                placeholder="Pilih"
                :value="programData.program_name"
                :isValid="validate.program_type.isValid"
                :invalidFeedback="validate.program_type.message"
                @change="handleProgramType"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Active Date"
                class="mb-0 required"
                type="datetime-local"
                required
                horizontal
                placeholder="Nama Program"
                :isValid="validate.active_date.isValid"
                :invalidFeedback="validate.active_date.message"
                @change="handleActiveDate"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Expired Date"
                class="mb-0 required"
                type="datetime-local"
                required
                horizontal
                placeholder="Nama Program"
                :isValid="validate.expiry_date.isValid"
                :invalidFeedback="validate.expiry_date.message"
                @change="handleExpireDate"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12" v-if="programType === 'With Content'">
              <a>Deskripsi Promo</a>
             <editor
                id="editor"
                :class="showErrorField && !programData.program_description ? 'is-invalid' : ''"
                :api-key="tinyMceKey"
                :init="initOption"
                v-model="programData.program_description"
              />
               <div class="invalid-feedback">
                {{validate.program_description.message}}
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12" v-if="programType === 'With Content'">
              <a>Syarat & Ketentuan</a>
              <editor
                id="editor2"
                :class="showErrorField && !programData.program_term_condition ? 'is-invalid' : ''"
                :api-key="tinyMceKey"
                :init="initOption"
                v-model="programData.program_term_condition"
              />
              <div class="invalid-feedback">
                {{validate.program_term_condition.message}}
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="programType === 'Fix Link'">
            <CCol :col="8">
              <CInput
                label="URL Link"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="URL Link (https://example.com)"
                @change="handleProgramUrl"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Banner Image File"
                horizontal
                class="required"
                type="file"
                :isValid="validate.attachment_program_photo_url.isValid"
                :invalidFeedback="validate.attachment_program_photo_url.message"
                @change="handleProgramPhotoUrl"
                accept=".png, .jpg, .jpeg, .webp"
              >
              <template v-slot:label-after-input>
                File size should be below 250KB and Optimize picture size is 720px
                x 360px.
              </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img
                class="image-ilustrasi"
                id="myImg"
                v-if="url"
                :src="url" />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="ALT Banner Image"
                class="mb-0"
                type="text"
                horizontal
                placeholder="ALT Banner Image"
                v-model="programData.alt_program_photo_url"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Promo Image Card"
                horizontal
                class="required"
                type="file"
                accept=".png, .jpg, .jpeg, .webp"
                :isValid="validate.attachment_program_subphoto_url.isValid"
                :invalidFeedback="validate.attachment_program_subphoto_url.message"
                @change="handleProgramSubPhotoUrl"
              >
                <template v-slot:label-after-input>
                     File size should be below 150KB and Optimize picture size is 300px x 150px
                </template>
              </CInputFile>
            
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img
                class="image-ilustrasi"
                id="myImg"
                v-if="subPhotoUrl"
                :src="subPhotoUrl"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="ALT Card Image"
                class="mb-0"
                type="text"
                horizontal
                placeholder="ALT Card Image"
                v-model="programData.alt_program_subphoto_url"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="Trending Promo Image"
                  horizontal
                  :class="programData.is_trending === 'Yes' ? 'required' : ''"
                  type="file"
                  accept=".png, .jpg, .jpeg, .webp"
                  :isValid="validate.attachment_program_trending_url.isValid"
                  :invalidFeedback="validate.attachment_program_trending_url.message"
                  @change="handleProgramTrendingPhotoUrl"
              >
                <template v-slot:label-after-input>
                  File size should be below 150KB and Optimize picture size is 1032px x 292px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="8">
              <img
                  class="image-ilustrasi"
                  id="trendingImg"
                  v-if="trendingPhotoUrl"
                  :src="trendingPhotoUrl"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Show Section POS Interpack"
                :options="optionsShowSectionPOSInterpack"
                required
                horizontal
                :value="programData.show_pos_interpack"
                @change="handleShowSectionPOSInterpack"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Channel Promo"
                placeholder="Pilih channel promo"
                :options="optionsProgramChannel"
                required
                horizontal
                class="required"
                :value="programData.program_channel"
                :isValid="validate.program_channel.isValid"
                :invalidFeedback="validate.program_channel.message"
                @change="handleProgramChannel"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Trending Promo"
                :options="optionsTrending"
                required
                horizontal
                :value="programData.is_trending"
                @change="handleTrending"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Country"
                :options="optionsCountry"
                required
                horizontal
                :value="programData.country"
                @change="handleCountry"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Language"
                :options="filteredLanguages"
                required
                horizontal
                :value="programData.program_language"
                :disabled="programData.country === 'malaysia'"
                @change="handleLanguage"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                @click="createNewProgram"
                >Save</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";
import Editor from "@tinymce/tinymce-vue";
import initTinymce from "@/app/constants/initTinymce";


export default {
  name: "ProgramCreate",
  components: { Editor },
  data() {
    return {
      tinyMceKey: initTinymce.key,
      programData: {
        program_name: "",
        program_type: "",
        active_date: "",
        expiry_date: "",
        program_url: "",
        program_slug: "",
        program_description: "",
        program_term_condition: "",
        attachment_program_photo_url: null,
        alt_program_photo_url: "",
        attachment_program_subphoto_url: null,
        alt_program_subphoto_url: "",
        attachment_program_trending_url: null,
        status: "",
        meta_info_description: '',
        meta_info_keyword: '',
        show_pos_interpack: false,
        program_channel: "",
        is_trending: "No",
        program_language: "ID",
        country: "indonesia",
      },
      showErrorField: false,
      programType: "",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      options: ["With Content", "Fix Link"],
      optionsStatus: ["ACTIVE", "INACTIVE"],
      optionsShowSectionPOSInterpack: [{value: true, label: "ACTIVE"}, {value: false, label: "INACTIVE"}],
      optionsProgramChannel: [{value: "retail", label: "Retail"}, {value: "app-web", label: "Aplikasi & Website"}],
      optionsTrending: ["No", "Yes"],
      content1: "",
      content2: "",
      url: null,
      subPhotoUrl: null,
      bannerImgDimension: {},
      cardImgDimension: {},
      initOption: initTinymce.init,
      trendingPhotoUrl: null,
      trendingImgDimension: {},
      optionsLanguage: [
        { label: "Indonesia", value: "ID" },
        { label: "English", value: "EN" },
      ],
      optionsCountry: [
        { label: "Indonesia", value: "indonesia" },
        { label: "Malaysia", value: "malaysia" },
      ],
    };
  },
  mounted() {
    this.authentication();
  },
  computed: {
    filteredLanguages() {
      if (this.programData.country === "malaysia") {
        return this.optionsLanguage.filter(lang => lang.value === "EN");
      }
      return this.optionsLanguage;
    },
    validate() {
      return {
        program_name: {
          isValid: this.checkIsValid(this.programData.program_name),
          error: !this.programData.program_name,
          message: "Nama Program harus diisi"
        },
        program_slug: {
          isValid: this.checkIsValid(this.programData.program_slug),
          error: !this.programData.program_slug,
          message: "Program URL Name harus diisi"
        },
        program_type: {
          isValid: this.checkIsValid(this.programData.program_type),
          error: !this.programData.program_type,
          message: "Jenis Program harus diisi"
        },
        active_date: {
          isValid: this.checkIsValid(this.programData.active_date),
          error: !this.programData.active_date,
          message: "Active Date harus diisi"
        },
        expiry_date: {
          isValid: this.checkIsValid(this.programData.expiry_date),
          error: !this.programData.expiry_date,
          message: "Expired Date harus diisi"
        },
        program_description: {
          isValid: this.checkIsValid(this.programData.program_description),
          error: this.programData.program_type === "With Content" && !this.programData.program_description,
          message: "Deskripsi harus Diisi"
        },
        program_term_condition: {
          isValid: this.checkIsValid(this.programData.program_term_condition),
          error: this.programData.program_type === "With Content" && !this.programData.program_term_condition,
          message: "Syarat harus Diisi"
        },
        program_channel: {
          isValid: this.checkIsValid(this.programData.program_channel),
          error: !this.programData.program_channel,
          message: "Channel Promo harus diisi"
        },
        attachment_program_photo_url: {
          ...this.decideBannerImageError()
        },
        attachment_program_subphoto_url: {
          ...this.decideCardImageError()
        },
        attachment_program_trending_url: {
          ...this.decideTrendingImageError()
        },

      }
    },
    errorForms() {
      return Object.values(this.validate).filter((form) => form.error === true)[0]
    },
    isFormValueEmpty() {
      return Object.values(this.programData).filter((form) => form)
    },
    getImgDimension() {
      return {banner: this.bannerImgDimension, card: this.cardImgDimension}
    }
  },
  methods: {
    decideBannerImageError() {
      if (!this.programData.attachment_program_photo_url) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Banner Image File harus diisi"
        }
      }
      if (this.programData.attachment_program_photo_url && 
        this.programData.attachment_program_photo_url["size"] > 250000
      ) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "File size should be below 250KB"
        }
      }
      if (
        (this.getImgDimension.banner.width !== 720) ||
        (this.getImgDimension.banner.height !== 360)
        ) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Picture must be size is 720px x 360px"
        }
      } 
      return {
        error: false,
        isValid: null,
        message: ""
      }
    },
    decideCardImageError() {
      if (!this.programData.attachment_program_subphoto_url) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Promo Image Card harus diisi"
        }
      }
      if (this.programData.attachment_program_subphoto_url && 
        this.programData.attachment_program_subphoto_url["size"] > 150000
      ) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "File size should be below 250KB"
        }
      }
      if (
        (this.getImgDimension.card.width !== 300) ||
        (this.getImgDimension.card.height !== 150)
        ) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Picture must be size is 300px x 150px"
        }
      }
      return {
        error: false,
        isValid: null,
        message: ""
      }
    },
    decideTrendingImageError() {
      if (this.programData.is_trending === "No") {
        return {
          error: false,
          isValid: null,
          message: ""
        }
      }

      if (!this.programData.attachment_program_trending_url) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Trending Image harus diisi karena Trending Promo = Yes"
        }
      }

      if (
          (this.trendingImgDimension.width !== 1032) ||
          (this.trendingImgDimension.height !== 292)
      ) {
        return {
          error: true,
          isValid: this.checkIsValid(false),
          message: "Picture must be size is 1032px x 292px"
        }
      }

      return {
        error: false,
        isValid: null,
        message: ""
      }
    },
    checkIsValid(val) {
      return this.showErrorField && !val ? false : null
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      if (this.isFormValueEmpty.length) {
        return Swal.fire({
          icon: "info",
          title: "Are you sure want to leave?",
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
          showCloseButton: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.usersOpened
              ? this.$router.go(-1)
              : this.$router.push({ path: "/management/program/list" });
          }
        })
      } else {
          this.usersOpened
            ? this.$router.go(-1)
            : this.$router.push({ path: "/management/program/list" });
      }
    },
    handleProgramType(event) {
      this.programType = event.target.value;
      this.programData.program_type = event.target.value;
    },
    handleProgramName(event) {
      var slug = event
        .replaceAll(/[^A-Za-z0-9 -]/g, "")
        .replaceAll(" ", "-")
        .replaceAll("--", "-")
        .toLowerCase()
        .trim();
      document.getElementById("program_slug").value = slug;
      this.handleProgramSlug(slug)
      this.programData.program_slug = slug;
      this.programData.program_name = event;
    },
    handleProgramSlug(event) {
      var slug = event
        .replaceAll(/[^A-Za-z0-9 -]/g, "")
        .replaceAll(" ", "-")
        .replaceAll("--", "-")
        .toLowerCase()
        .trim();
      document.getElementById("program_slug").value = slug;
      this.programData.program_slug = slug;
    },
    handleActiveDate(event) {
      this.programData.active_date = event;
    },
    handleExpireDate(event) {
      this.programData.expiry_date = event;
    },
    handleProgramUrl(event) {
      this.programData.program_url = event;
    },
    async handleProgramPhotoUrl(event) {
      if (event.length) {
        const file = event[0];
        this.url = URL.createObjectURL(file);
        this.bannerImgDimension = await this.addImageProcess(this.url)
        this.programData.attachment_program_photo_url = event[0];
      }
    },
    async handleProgramSubPhotoUrl(event) {
      if (event.length) {
        const file = event[0];
        this.subPhotoUrl = URL.createObjectURL(file);
        this.cardImgDimension = await this.addImageProcess(this.subPhotoUrl)
        this.programData.attachment_program_subphoto_url = event[0];
      }
    },
    handleStatusProgram(event) {
      this.programData.status = event.target;
    },
    handleShowSectionPOSInterpack(event) {
      this.programData.show_pos_interpack = event.target.value;
    },
    handleProgramChannel(event) {
      this.programData.program_channel = event.target.value;
    },
    handleTrending(event) {
      this.programData.is_trending = event.target.value;
    },
    handleLanguage(event) {
      if (this.programData.country === "malaysia") {
        this.programData.program_language = "EN";
        return;
      }

      this.programData.program_language = event.target.value;
    },
    handleCountry(event) {
      this.programData.country = event.target.value;

      if (this.programData.country === "malaysia") {
        this.programData.program_language = "EN";
      }
    },
    createNewProgram() {
      this.showErrorField = true
      if (this.errorForms && this.errorForms.error) {
        return 
      }
      let formData = new FormData();
      formData.append("meta_info_description", this.programData.meta_info_description);
      formData.append("meta_info_keyword", this.programData.meta_info_keyword);
      formData.append("program_name", this.programData.program_name);
      formData.append("program_slug", this.programData.program_slug);
      formData.append("program_type", this.programData.program_type);
      formData.append("active_date", moment(this.programData.active_date).format());
      formData.append("expiry_date", moment(this.programData.expiry_date).format());
      formData.append(
        "program_description",
        this.programData.program_description
      );
      formData.append(
        "program_term_condition",
        this.programData.program_term_condition
      );
      formData.append("program_url", this.programData.program_url);
      formData.append(
        "attachment_program_photo_url",
        this.programData.attachment_program_photo_url
      );
      formData.append("alt_program_photo_url", this.programData.alt_program_photo_url);
      formData.append(
        "attachment_program_subphoto_url",
        this.programData.attachment_program_subphoto_url
      );
      formData.append("alt_program_subphoto_url", this.programData.alt_program_subphoto_url);
      formData.append("status", this.programData.status);
      formData.append("show_pos_interpack", this.programData.show_pos_interpack);
      formData.append("program_channel", this.programData.program_channel);
      formData.append("is_trending", this.programData.is_trending);
      formData.append(
          "attachment_program_trending_url",
          this.programData.attachment_program_trending_url
      );
      formData.append("lang", this.programData.program_language);
      formData.append("country", this.programData.country);

      axios
        .post(`${this.domain}/v1/program`, formData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Program Data Created`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/management/program/list` });
        })
        .catch((err) => {
          const error = err.response.data.message?.id || err.response.data.desc?.id || "Something went wrong";
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error,
          });
        });
    },
    addImageProcess(src){
      return new Promise((resolve, reject) => {
        let img = new Image()
        img.onload = () => resolve({width: img.width, height: img.height})
        img.onerror = reject
        img.src = src
      })
    },
    async handleProgramTrendingPhotoUrl(event) {
      if (event.length) {
        const file = event[0];
        this.trendingPhotoUrl = URL.createObjectURL(file);
        this.trendingImgDimension = await this.addImageProcess(this.trendingPhotoUrl);
        this.programData.attachment_program_trending_url = event[0];

      }
    },

  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
@import "./Program.css";
</style>
<style>
.form-group.required .col-form-label::after {
  content: "*";
  color: red;
}
.form-row.required .col-form-label::after {
  content: "*";
  color: red;
}

</style>
